(function ($) {
  'use strict';
  Drupal.behaviors.mainMenuFooter = {
    attach: function attach(context) {
      let dropDownLinks = $('footer .menu li.menu-item--expanded');
      dropDownLinks.each(function(){
        Drupal.accordeonize($(this), $(this).find('> a'), $(this).find('.menu_link_content'));
      });
    }
  };
})(jQuery, Drupal);

(function (Drupal) {
  'use strict';

  Drupal.behaviors.menuToggleWithJsClasses = {
    attach: function (context, settings) {

      const regionFooter = document.querySelector('.region-footer');
      if (regionFooter) {
        const logoContainer = regionFooter.querySelector('.footer__logo');
        if (logoContainer) {
          const img = logoContainer.querySelector('img');
          if (img) {
            img.src = '/themes/custom/passpass/logo.svg';
          }
        }
      }

      if (Drupal.is_portraitPhones()) {
        const aideMenuTitles = once('toggle-aide-menu', '#block-passpass-aide-menu', context);
        const contactMenuTitles = once('toggle-contact-menu', '#block-passpass-contact-2-menu', context);

        function toggleMenu(event) {
          event.preventDefault();

          const menuTitle = event.target;
          const menuList = menuTitle.nextElementSibling.classList.contains('contextual') ? menuTitle.nextElementSibling.nextElementSibling : menuTitle.nextElementSibling;

          if (menuList.classList.contains('active')) {
            menuList.classList.remove('active');
            menuTitle.classList.remove('active');
          } else {
            menuList.classList.add('active');
            menuTitle.classList.add('active');
          }
        }
        aideMenuTitles.forEach(title => title.addEventListener('click', toggleMenu));
        contactMenuTitles.forEach(title => title.addEventListener('click', toggleMenu));
      }
    }
  };
})(Drupal);